<template>
    <div>
        <RightPanelModal v-model="showPanel">
            <template #title>
                <div style="width: 100%" class="d-flex align-center justify-space-between">
                    <span class="pa-3 pb-0"> Event Super </span>
                    <v-btn @click="togglePanel" fab small depressed>
                        <font-awesome-icon icon="fa-regular fa-x"></font-awesome-icon>
                    </v-btn>
                </div>
            </template>

            <template #content>
                <v-card-text>
                    <v-row v-if="formData">
                        <v-col cols="12" md="6" class="pointer" @click="copyToClipboard(formData.id)">
                            <v-text-field label="Id" disabled v-model="formData.id"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer" @click="copyToClipboard(formData.externalId)">
                            <v-text-field label="External Id" disabled v-model="formData.externalId"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer" @click="copyToClipboard(formData.funeralHomeId)">
                            <v-text-field
                                label="Funeral Home Id"
                                disabled
                                v-model="formData.funeralHomeId"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Service Id" disabled v-model="formData.serviceId"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer" @click="copyToClipboard(formData.createDate)">
                            <calendar datetime disabled v-model="formData.createDate" label="Create Date" />
                        </v-col>
                        <v-col cols="12" md="6" class="pointer" @click="copyToClipboard(formData.liveSecondsConsumed)">
                            <v-text-field
                                label="Live Seconds Consumed"
                                disabled
                                v-model="formData.liveSecondsConsumed"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Service Slug" v-model="formData.serviceSlug"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <calendar datetime v-model="formData.time" label="Time" />
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <!-- <v-text-field label="Event Status" v-model="formData.eventStatus"></v-text-field> -->
                            <v-select
                                :items="eventStates"
                                item-text="label"
                                item-value="value"
                                label="Event Status"
                                v-model="formData.eventStatus"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <!-- <v-text-field label="Event Type" v-model="formData.eventType"></v-text-field> -->

                            <v-select
                                :items="serviceEventTypes"
                                item-text="label"
                                item-value="value"
                                label="Event Type"
                                v-model="formData.eventType"
                            ></v-select>
                        </v-col>

                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Title" v-model="formData.title"></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Converted Video" v-model="formData.convertedVideo"> </v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Intro Video" v-model="formData.introVideo"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Hidden" v-model="formData.hidden"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Live" v-model="formData.live"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Live Stream Id" v-model="formData.liveStreamId"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Live URL" v-model="formData.liveURL"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer" @click="copyToClipboard(formData.media)">
                            <v-text-field label="Media" disabled v-model="formData.media"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Notes" v-model="formData.notes"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Order" v-model="formData.order"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Passare Event Uuid" v-model="formData.passareEventUuid"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Pin" v-model="formData.pin"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="PreviewText" v-model="formData.previewText"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pointer">
                            <v-text-field label="Private" v-model="formData.private"></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            md="6"
                            class="pointer"
                            @click="copyToClipboard(formData.problemAtStreamBadHealth)"
                        >
                            <v-text-field
                                label="ProblemAtStreamBadHealth"
                                v-model="formData.prioblemAtStreamBadHealth"
                            ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            md="6"
                            class="pointer"
                            @click="copyToClipboard(formData.problemAtStreamNotStarted)"
                        >
                            <v-text-field
                                label="ProblemAtStreamNotStarted"
                                v-model="formData.prioblemAtStreamNotStarted"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </template>

            <template #actions>
                <div class="p-3 pt-0 d-flex flex-wrap" style="width: 100%; gap: 12px">
                    <div class="flex-grow-1">
                        <v-btn class="no-text-transform" outlined depressed block @click="togglePanel"> Close</v-btn>
                    </div>
                    <div class="flex-grow-1">
                        <v-btn
                            @click="updateEvent(eventId)"
                            :disabled="loading"
                            :loading="loading"
                            depressed
                            class="no-text-transform"
                            color="#ff530d"
                            block
                            :dark="!loading"
                            >Save</v-btn
                        >
                    </div>
                </div>
            </template>
        </RightPanelModal>

        <slot name="activator" :on-click="togglePanel"> </slot>
    </div>
</template>
<script>
import RightPanelModal from '@/components/Tribute/Layout/RightPanelModal.vue';
import EventsService from '@/services/events.service';
import { mapActions } from 'pinia';
import Calendar from '../../ui/Calendar.vue';
import { serviceEventTypes, eventStates } from '@/constants';
import { useTributeVideoStore } from '@/stores/tributeVideo';
import { useGlobalState } from '@/stores/globalState';
export default {
    setup() {
        return {
            tributeVideoStore: useTributeVideoStore(),
        }
    },
    data() {
        return {
            eventApi: null,
            loading: false,
            formData: null,
            showPanel: false,
            serviceEventTypes,
            eventStates,
        };
    },
    components: { RightPanelModal, Calendar },
    props: {
        eventId: {
            type: Number,
            required: true,
        },
    },
    watch: {
        showPanel(newVal) {
            if (newVal) {
                this.getEvent(this.eventId);
            }
        },
    },
    methods: {
        ...mapActions(useGlobalState, ['showSnackbar']),

        copyToClipboard(val) {
            navigator.clipboard.writeText(val);
            this.showSnackbar({ message: 'Copied to Clipboard' });
        },
        togglePanel() {
            this.showPanel = !this.showPanel;
        },
        async setAuthToken() {
            const response = await this.$auth.getIdTokenClaims();
            this.token = response.__raw;
        },

        parseDate(date) {
            if (date) {
                const localDate = this.$moment.utc(date).local();
                return localDate.toISOString();
            }
        },

        async updateEvent(eventId) {
            try {
                this.loading = true;

                console.log(this.formData, 'event form data to save');

                let data = this.formData;

                await this.eventApi.updateAdmin(eventId, data);

                this.showSnackbar({ message: 'Event updated' });
            } catch (error) {
                console.log(error, 'error updating event');
                this.showSnackbar({ message: 'Error updating event', color: 'error' });
            } finally {
                this.loading = false;
            }
        },
        async getEvent(eventId) {
            try {
                this.loading = true;
                const resp = await this.eventApi.getAdmin(eventId);

                if (resp.data) {
                    this.formData = { ...resp.data };
                    this.formData.createDate = this.parseDate(this.formData.createDate);
                    this.formData.time = this.parseDate(this.formData.time);
                }
            } catch (error) {
                console.log(error, 'error fetching tribute');
            } finally {
                this.loading = false;
            }
        },
    },
    async mounted() {
        await this.setAuthToken();
        this.eventApi = EventsService(this.token);

        this.getEvent(this.eventId);
    },
};
</script>
<style lang="scss" scoped></style>
